import React, {Dispatch, ReactNode, SetStateAction} from 'react';

import Table, {SetOrderByType} from 'shared/ui/Table/Table';
import IPagination from 'shared/api/model/IPagination';
import IOrderBy from 'shared/model/IOrderBy';
import IPortIncident from 'features/port/model/PortIncident/IPortIncident';
import {getPortIncidentColumns} from 'features/port/lib/portIncidentHelper';

import PortIncidentRow from '../PortIncidentRow/PortIncidentRow';

interface IPortIncidentsProps {
    pagination?: IPagination<IPortIncident>,
    isLoading: boolean,
    tzString?: string | null,
    hideMonitor?: boolean,
    hidePagination?: boolean,
    sort?: IOrderBy,
    setSort?: SetOrderByType,
    setPage?: Dispatch<SetStateAction<number>>,
    className?: string,
    emptyStateComponent?: ReactNode,
}

const PortIncidents: React.FC<IPortIncidentsProps> = ({
    pagination,
    isLoading,
    tzString,
    hideMonitor = false,
    hidePagination = false,
    sort,
    setSort,
    setPage,
    className,
    emptyStateComponent = true,
}) => (
    <Table
        columns={getPortIncidentColumns(hideMonitor)}
        items={pagination?.items}
        rowFactory={(item) => (
            <PortIncidentRow
                key={item.uuid}
                item={item}
                tzString={tzString}
                hideMonitor={hideMonitor}
            />
        )}
        isLoading={isLoading}
        pagination={pagination && !hidePagination ? pagination : undefined}
        sort={sort}
        setSort={setSort}
        setPage={setPage}
        className={className}
        emptyStateComponent={emptyStateComponent}
    />
);

export default PortIncidents;
